<template>
    <div class="analysisTable">
        <div class="analysisTable__header">
            <div class="analysisTable__header--icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
                    <path
                        d="M22.6979 16.9214C22.6979 16.3691 22.2501 15.9214 21.6979 15.9214C21.1456 15.9214 20.6979 16.3691 20.6979 16.9214H22.6979ZM16.9214 20.6979C16.3691 20.6979 15.9214 21.1456 15.9214 21.6979C15.9214 22.2501 16.3691 22.6979 16.9214 22.6979V20.6979ZM16.9214 0C16.3691 0 15.9214 0.447715 15.9214 1C15.9214 1.55228 16.3691 2 16.9214 2V0ZM21.2315 1.46633L21.9387 0.759291L21.9387 0.759289L21.2315 1.46633ZM20.6979 5.77643C20.6979 6.32871 21.1456 6.77643 21.6979 6.77643C22.2501 6.77643 22.6979 6.32871 22.6979 5.77643H20.6979ZM0 5.77643C0 6.32871 0.447715 6.77643 1 6.77643C1.55228 6.77643 2 6.32871 2 5.77643H0ZM1.46633 1.46633L0.759223 0.759219L0.759219 0.759223L1.46633 1.46633ZM5.77643 2C6.32871 2 6.77643 1.55228 6.77643 1C6.77643 0.447715 6.32871 0 5.77643 0V2ZM5.77643 22.6979C6.32871 22.6979 6.77643 22.2501 6.77643 21.6979C6.77643 21.1456 6.32871 20.6979 5.77643 20.6979V22.6979ZM1.46633 21.2315L0.759289 21.9387L0.759291 21.9387L1.46633 21.2315ZM2 16.9214C2 16.3691 1.55228 15.9214 1 15.9214C0.447715 15.9214 0 16.3691 0 16.9214H2ZM17.4045 17.7177V18.7177H18.7754L18.3567 17.4123L17.4045 17.7177ZM15.0969 14.5222L15.6862 13.7143L15.6862 13.7143L15.0969 14.5222ZM7.60201 14.5222L7.01268 13.7143L7.01267 13.7143L7.60201 14.5222ZM5.29444 17.7177L4.3422 17.4123L3.92363 18.7177H5.29444V17.7177ZM20.6979 16.9214V20.1057H22.6979V16.9214H20.6979ZM20.6979 20.1057C20.6979 20.2627 20.6354 20.4134 20.5244 20.5244L21.9386 21.9386C22.4247 21.4526 22.6979 20.7932 22.6979 20.1057H20.6979ZM20.5244 20.5244C20.4134 20.6354 20.2627 20.6979 20.1057 20.6979V22.6979C20.7932 22.6979 21.4526 22.4247 21.9386 21.9386L20.5244 20.5244ZM20.1057 20.6979H16.9214V22.6979H20.1057V20.6979ZM16.9214 2H20.1057V0H16.9214V2ZM20.1057 2C20.2628 2 20.4134 2.06242 20.5243 2.17337L21.9387 0.759289C21.4526 0.273063 20.7931 0 20.1057 0V2ZM20.5243 2.17336C20.6355 2.28452 20.6979 2.43519 20.6979 2.59214H22.6979C22.6979 1.90455 22.4246 1.24531 21.9387 0.759291L20.5243 2.17336ZM20.6979 2.59214V5.77643H22.6979V2.59214H20.6979ZM2 5.77643V2.59214H0V5.77643H2ZM2 2.59214C2 2.43509 2.06238 2.28448 2.17344 2.17343L0.759219 0.759223C0.273102 1.24534 0 1.90466 0 2.59214H2ZM2.17343 2.17344C2.28448 2.06238 2.43509 2 2.59214 2V0C1.90466 0 1.24534 0.273102 0.759223 0.759219L2.17343 2.17344ZM2.59214 2H5.77643V0H2.59214V2ZM5.77643 20.6979H2.59214V22.6979H5.77643V20.6979ZM2.59214 20.6979C2.43519 20.6979 2.28452 20.6355 2.17336 20.5243L0.759291 21.9387C1.24531 22.4246 1.90455 22.6979 2.59214 22.6979V20.6979ZM2.17337 20.5243C2.06242 20.4134 2 20.2628 2 20.1057H0C0 20.7931 0.273063 21.4526 0.759289 21.9387L2.17337 20.5243ZM2 20.1057V16.9214H0V20.1057H2ZM11.3486 11.5528C13.6595 11.5528 15.5329 9.67946 15.5329 7.36856H13.5329C13.5329 8.57489 12.555 9.55283 11.3486 9.55283V11.5528ZM15.5329 7.36856C15.5329 5.05765 13.6595 3.18429 11.3486 3.18429V5.18429C12.555 5.18429 13.5329 6.16222 13.5329 7.36856H15.5329ZM11.3486 3.18429C9.0377 3.18429 7.16436 5.05766 7.16436 7.36856H9.16436C9.16436 6.16222 10.1423 5.18429 11.3486 5.18429V3.18429ZM7.16436 7.36856C7.16436 9.67945 9.0377 11.5528 11.3486 11.5528V9.55283C10.1423 9.55283 9.16436 8.57489 9.16436 7.36856H7.16436ZM18.3567 17.4123C17.8806 15.9278 16.9455 14.633 15.6862 13.7143L14.5075 15.3301C15.4246 15.9991 16.1055 16.942 16.4523 18.0231L18.3567 17.4123ZM15.6862 13.7143C14.4268 12.7956 12.9083 12.3006 11.3494 12.3006V14.3006C12.4846 14.3006 13.5905 14.6611 14.5075 15.3301L15.6862 13.7143ZM11.3494 12.3006C9.7906 12.3006 8.27204 12.7956 7.01268 13.7143L8.19134 15.3301C9.10844 14.6611 10.2143 14.3006 11.3494 14.3006V12.3006ZM7.01267 13.7143C5.75331 14.633 4.81821 15.9278 4.3422 17.4123L6.24668 18.023C6.59332 16.9419 7.27425 15.9991 8.19135 15.3301L7.01267 13.7143ZM5.29444 18.7177H17.4045V16.7177H5.29444V18.7177Z"
                        fill="#3682F3" />
                </svg>
            </div>
            <div class="analysisTable__header--title">Cliente</div>
        </div>
        <div class="analysisTable__content" v-if="!isLoading">
            <div class="analysisTable__content--list">
                <div class="analysisTable__content--list-item">
                    <div class="item">
                        <div class="item__container">
                            <div class="item__container--title">Nome</div>
                            <div class="item__container--value">{{ name }}</div>
                            <div class="item__container--pill blue">{{ client_id }}</div>
                        </div>
                    </div>
                </div>
                <div class="analysisTable__content--list-item">
                    <div class="item">
                        <div class="item__container">
                            <div class="item__container--title">Telefone</div>
                            <div class="item__container--value">{{ telefone }}</div>
                            <div class="item__container--pill" 
                                :class="countTelefone > 5 ? 'red' : 'blue'">
                                {{ countTelefone }}</div>
                        </div>
                    </div>
                </div>
                <div class="analysisTable__content--list-item">
                    <div class="item">
                        <div class="item__container">
                            <div class="item__container--title">Email</div>
                            <div class="item__container--value">{{ email }}</div>
                            <div class="item__container--pill"
                                :class="countEmail > 5 ? 'red' : 'blue'">{{ countEmail }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="analysisTable__content--list-item no-border">
                    <div class="item">
                        <div class="item__container">
                            <div class="item__container--title">Cpf</div>
                            <div class="item__container--value">{{ cpf }}</div>
                            <div class="item__container--pill" 
                                :class="countCpf > 5 ? 'red' : 'blue'">{{ countCpf }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="row justify-content-center p-5">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    name: 'AnalysisTableClient',
    props: {
        data: {
            type: Object,
            required: true
        },
        totalizer: {
            type: Object,
            required: false
        },
    },
    computed: {
        isLoading() {
            return this.$store.getters["getLoadingAnalysisSelldata"]
        },
        name() {
            return this.data && this.data.client && this.data.client.name ? this.data.client.name : '---';
        },
        client_id() {
            return this.data && this.data.client && this.data.client.id ? '#' + this.data.client.id : '---';
        },
        telefone() {
            return this.data && this.data.client && this.data.client.cellphone ?  this.data.client.cellphone : '---';
        },
        email() {
            return this.data && this.data.client && this.data.client.email ? this.data.client.email : '---';
        },
        cpf() {
            return this.data && this.data.client &&this.data.client.document ? this.data.client.document : '---';
        },
        countTelefone() {
            if (!this.totalizer || !this.totalizer.count) {
                return 0
            }
            return this.totalizer && this.totalizer.count && this.totalizer.count.phone ? this.totalizer.count.phone : '---';
        },
        countEmail() {
            if (!this.totalizer || !this.totalizer.count) {
                return 0
            }
            return this.totalizer && this.totalizer.count && this.totalizer.count.email ? this.totalizer.count.email : '---';
        },
        countCpf() {
            if (!this.totalizer || !this.totalizer.count) {
                return 0
            }
            return this.totalizer && this.totalizer.count && this.totalizer.count.cpf_cnpj ? this.totalizer.count.cpf_cnpj : '---';
        },

    },
};
</script>

<style scoped lang="scss">
.analysisTable {
    width: 100%;
    margin: 20px 0px 0px 0px;

    &__header {
        padding: 0px 20px;
        display: flex;
        justify-content: flex-start;

        &--icon {
            width: 20.698px;
            height: 20.698px;
            flex-shrink: 0;
        }

        &--title {
            color: #3682F3;
            font-size: 18px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
            margin-left: 14px;
        }
    }

    &__content {
        height: auto;
        width: 100%;

        hr {
            background: #E5E5E5;
        }

        &--list {
            height: auto;
            width: 100%;
            margin: 20px 0px;

            .item {
                border-bottom: solid 1px #E5E5E5;
                position: relative;

                &__container {
                    padding: 20px;

                    &--title {
                        color: #B1B1B1;
                        font-size: 0.8em;
                        font-style: normal;
                        font-weight: 400;
                        line-height: normal;
                    }

                    &--value {
                        color: #141414;
                        font-size: 0.9em;
                        font-style: normal;
                        font-weight: 600;
                        line-height: normal;
                        width: calc(100% - 40px);
                        overflow-x: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                    }

                    &--pill {
                        position: absolute;
                        right: 20px;
                        top: 30%;
                        width: auto;
                        font-size: 0.7em;
                        padding: 4px 10px;
                        font-size: 12px;
                        font-style: normal;
                        font-weight: 600;
                        line-height: normal;
                        border-radius: 50px;


                    }
                }

            }
            .no-border .item {
                border-bottom: none;
            }

        }
    }
}

.blue {
    background: rgba(54, 130, 243, 0.10);
    color: #3682F3;
}

.red {
    background: rgba(255, 95, 95, 0.10);
    color: #FF5F5F;
}
</style>